module.exports = __webpack_public_path__ + "img/private.960060bb.svg";